import React from "react";
import vac from "../../DashboardContainer/Component/NewUiimg/vac.png";

const StudentCard = ({
  props,
  isOpen,
  toggleModal,
  modalRef,
  YearsOptions,
  extractSixBySix,
  MonthOption,

  student,
  checkAilmentKeyExists,

  initials = "NA",
  weightChange,
  isReportAvailable = false,
  downloadStudentReport = () => {},
}) => {
  return (
    <div className={`col-md-12  borderRadius ${isOpen ? "modal-open" : ""}`}>
      <div className="row">
        <div
          className="vaccinaitons-btn d-flex justify-content-end "
          style={{ marginBottom: "-90px", height: "90px" }}
        >
          <button className="vac-btn" href="/">
            <div className="drptxtnew mx-2" onClick={toggleModal}>
              <img className="injection" src={vac}></img>{" "}
              <p className="vac-txt">VACCINATIONS</p>
            </div>
          </button>{" "}
        </div>

        {isOpen && (
          <div className="container modal-contanier" ref={modalRef}>
            <div className="modal-wrapper d-flex justify-content-center">
              <div
                onClick={toggleModal}
                className="modal fade in"
                style={{
                  display: "flex",
                  overflowY: "scroll",
                  backgroundColor: "rgba( 0 , 0 , 0 , 0.5 )",
                  cursor: "pointer",
                }}
                tabIndex={-1}
                role="dialog"
              >
                <div
                  onClick={(e) => e.stopPropagation()}
                  className="modal-dialog modal-xl z-999"
                  role="document"
                  style={{ marginTop: "90px", cursor: "default" }}
                >
                  <div className="modal-content m-content ">
                    <div className="modal-body">
                      <div className="Vaccination-parent-block col-md-12 my-5">
                        <div className="row col-md-12 header-row my-5 ">
                          <div
                            className="col-md-12 mx-5 d-flex Justify-content-evenly mx-3"
                            style={{ marginTop: "-32px" }}
                          >
                            <div
                              className="col-md-3"
                              style={{ marginLeft: "-34px" }}
                            >
                              <p className="vacview-txt">Vaccination</p>
                            </div>
                            <div className="col-md-3">
                              <p className="vacview-txt">AGE RECOMMENDED</p>
                            </div>
                            <div className="col-md-3">
                              <p className="vacview-txt">CATCH-UP PERiOD</p>
                            </div>
                            <div className="col-md-3">
                              <p className="vacview-txt">
                                AGE AT VACCINATION GIVEN
                              </p>
                            </div>
                          </div>
                          <div className="row my-3" ref={modalRef}>
                            <div className="col-md-12">
                              <div className="col-md-12">
                                {props.vaccines?.data.map((vaccine) => {
                                  const customJsonArray = JSON.parse(
                                    vaccine.custom_json,
                                  );
                                  const doseMap = props.studentList.reduce(
                                    (acc, student) => {
                                      student.student_inf?.forEach((info) => {
                                        if (info.vaccination) {
                                          info.vaccination &&
                                            info.vaccination.forEach((v) => {
                                              v.dose.forEach((d) => {
                                                if (!acc[d.index]) {
                                                  acc[d.index] = {};
                                                }
                                                acc[d.index][v.id] = {
                                                  yearGiven: d.yearGiven,
                                                  monthGiven: d.monthGiven,
                                                };
                                              });
                                            });
                                        }
                                      });
                                      return acc;
                                    },
                                    {},
                                  );

                                  const rows = customJsonArray.map(
                                    (data, index) => {
                                      const doseInfo = doseMap[index] || {};
                                      const vaccineId = vaccine.id;

                                      return (
                                        <div
                                          key={`${vaccineId}-${index}`}
                                          className="vaciination-first"
                                        >
                                          <div className="form-check vac-check">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value=""
                                              id={`vaccine-${vaccineId}`}
                                              checked={Object.keys(
                                                doseInfo,
                                              ).some((id) => id == vaccineId)}
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={`vaccine-${vaccineId}`}
                                            >
                                              <p className="sick-txt">{`${
                                                vaccine.name
                                              }${
                                                customJsonArray.length > 1
                                                  ? ` ${index + 1}`
                                                  : ""
                                              }`}</p>
                                            </label>

                                            <p
                                              className="d-flex sick-txt-light f-w"
                                              style={{
                                                marginLeft: "218px",
                                                marginTop: "-11px",
                                                fontSize: "12px",
                                              }}
                                            >
                                              {data.ageRecommended}
                                            </p>

                                            <p
                                              className="d-flex sick-txt-light f-w"
                                              style={{
                                                marginLeft: "428px",
                                                marginTop: "-22px",
                                                width: "20%",
                                                lineHeight: "15px",
                                                fontSize: "12px",
                                              }}
                                            >
                                              {data.catchUpPeriod}
                                            </p>

                                            <div
                                              className="sick-drp"
                                              style={{
                                                marginTop: "-27px",
                                                fontWeight: 600,
                                              }}
                                            >
                                              <select
                                                className={`sick-txt-light drp-sick-txt ${
                                                  Object.keys(
                                                    doseInfo,
                                                  ).includes(
                                                    vaccineId.toString(),
                                                  )
                                                    ? "given-vaccine"
                                                    : ""
                                                }`}
                                                name="selectAge"
                                                id={`year-${vaccineId}-${index}`}
                                                style={{
                                                  color: "#1E87F0",
                                                  background: "#eaf2fe",
                                                  border: "none",
                                                  borderBlock: "none",
                                                  outline: "none",
                                                  marginLeft: "630px",
                                                  cursor: "none",
                                                }}
                                                readOnly
                                                disabled
                                                value={
                                                  doseInfo[vaccineId]
                                                    ?.yearGiven || ""
                                                }
                                              >
                                                {YearsOptions}
                                              </select>
                                              <p
                                                className="sick-txt-light"
                                                style={{
                                                  marginLeft: "670px",
                                                  marginTop: "-14px",
                                                }}
                                              >
                                                Year(s)
                                              </p>
                                            </div>
                                            <div
                                              className="sick-drp"
                                              style={{
                                                marginTop: "-27px",
                                                fontWeight: 600,
                                                marginLeft: "88px",
                                                width: "30%",
                                              }}
                                            >
                                              <select
                                                className={`sick-txt-light drp-sick-txt ${
                                                  Object.keys(
                                                    doseInfo,
                                                  ).includes(
                                                    vaccineId.toString(),
                                                  )
                                                    ? "given-vaccine"
                                                    : ""
                                                }`}
                                                name="selectAge"
                                                id={`month-${vaccineId}-${index}`}
                                                style={{
                                                  color: "#1E87F0",
                                                  background: "#eaf2fe",
                                                  border: "none",
                                                  borderBlock: "none",
                                                  outline: "none",
                                                  marginLeft: "630px",
                                                  cursor: "none",
                                                }}
                                                readOnly
                                                disabled
                                                value={
                                                  doseInfo[vaccineId]
                                                    ?.monthGiven || ""
                                                }
                                              >
                                                {MonthOption}
                                              </select>
                                              <p
                                                className="sick-txt-light"
                                                style={{
                                                  marginLeft: "670px",
                                                  marginTop: "-14px",
                                                }}
                                              >
                                                Month(s)
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    },
                                  );

                                  return (
                                    <div
                                      key={vaccine.id}
                                      style={{ marginBottom: "10px" }}
                                    >
                                      {rows}
                                    </div>
                                  );
                                })}
                              </div>{" "}
                            </div>{" "}
                          </div>{" "}
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        className="btn btn-default modeclosebtn"
                        onClick={toggleModal}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}

        <div
          className="col-md-12 d-flex justify-content-end  h-0"
          style={{ marginLeft: "-150px" }}
        >
          <div className="fordownloadtab">
            <div className="dropdown ">
              <button
                className={
                  "student-profilecbse mt-5" +
                  (!isReportAvailable ? " disabled" : "")
                }
                href="/"
                disabled={!isReportAvailable}
                style={{
                  cursor: isReportAvailable ? "pointer" : "not-allowed",
                }}
              >
                <p
                  className="drptxtnew"
                  onClick={
                    isReportAvailable
                      ? () => downloadStudentReport(props.newStudent?.uuid)
                      : null
                  }
                >
                  DOWNLOAD CBSE REPORT
                </p>
              </button>
            </div>
          </div>
        </div>

        <div
          className="col-md-12 "
          style={{
            marginTop: "-120px",
            fontFamily: "Montserrat",
            fontSize: 12,
          }}
        >
          <div className="col-md-2 p-0">
            <h1
              className="under_circlenameNew  circle  mx-3"
              style={{ fontSize: "55px", color: "white" }}
            >
              {initials}
            </h1>
          </div>
          <div className="col-md-6">
            <div className="col-md-12 name_bold" style={{ margin: "auto" }}>
              <h1
                className="name_boldNew "
                style={{ width: "145%", marginLeft: "-43px" }}
              >
                {props.newStudent?.studentname || props.newStudent?.name}
              </h1>
            </div>
            <div className="lightfont " style={{ marginLeft: "-48px" }}>
              <div className="col-md-6">
                <p className=" d-flex ">
                  Class: {props.newStudent?.class} - {props.newStudent?.section}
                </p>
              </div>
              <div className="col-md-6">
                <div className=" d-flex ">
                  HSG ID:&nbsp;
                  <p style={{ fontWeight: 500 }}>{props.newStudent?.uuid}</p>
                </div>
              </div>
              <div className="col-md-6">
                <p className=" d-flex">Gender: {props.newStudent?.gender}</p>
              </div>

              <div className="col-md-6">
                {" "}
                <p className=" d-flex ">
                  Admin No: {props.newStudent?.admission_number}
                </p>
              </div>

              <div className="col-md-6">
                {" "}
                <p className=" d-flex ">
                  Blood Group:{" "}
                  {student.bloodGroup ? student.custom?.bloodGroup : "NA"}
                </p>
              </div>

              <div className="col-md-6">
                {" "}
                <p className=" d-flex ">D.O.B: {props.newStudent?.dob}</p>
              </div>
            </div>
          </div>

          <div className="col-md-4 ">
            <div className=" d-flex justify-content-center caution-block borderRadius">
              <div className=" my-3">
                {student[0].fivePerc ? (
                  <React.Fragment>
                    <p className="innercaution-style">
                      Healthy BMI range should be between {student[0].fivePerc}{" "}
                      to {student[0].eightyFivePerc}.
                    </p>
                    <div
                      className="d-flex innercaution-style justify-content-center "
                      style={{ color: "#EF343B", marginTop: "-1px" }}
                    >
                      {student[0]?.studentAssessmentAll?.filter(
                        (studentAssessment) =>
                          studentAssessment?.event_track_id ==
                          props?.startNodeMap?.[
                            props?.currentProgram?.billing?.id
                          ]?.id,
                      )[0]?.metric?.bmi !== "normal" &&
                        weightChange !== 0 && (
                          <p
                            className="d-flex innercaution-style justify-content-center"
                            style={{
                              color: "#EF343B",
                              marginTop: "-7px",
                              fontWeight: 500,
                            }}
                          >
                            Need to{" "}
                            {student[0].trueBMI > student[0].eightyFivePerc
                              ? "lose"
                              : "gain"}{" "}
                            {weightChange} KG(s)
                          </p>
                        )}
                    </div>
                  </React.Fragment>
                ) : (
                  <div className="d-flex justify-content-center">
                    {" "}
                    Data is Not Available
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="preview-block borderRadius" style={{ marginTop: "20px" }}>
        <div className="row">
          <div className="col-md-12 d-flex justify-content-evenly mx-1 my-2">
            <div className="col-md-2">
              <p className="preview-block-innercontent my-3">
                Height:{" "}
                {student[0]?.studentAssessment?.[0]?.metric?.anthro?.height ||
                  "NA"}
              </p>
            </div>
            <div className="col-md-2">
              <p className="preview-block-innercontent my-3">
                Weight:{" "}
                {student[0]?.studentAssessment?.[0]?.metric?.anthro?.weight ||
                  "NA"}
              </p>
            </div>
            <div className="col-md-2">
              <div
                className="preview-block-innercontent my-3"
                style={{ display: "flex", width: "123%" }}
              >
                BMI:&nbsp;{student[0]?.trueBMI || "NA"}{" "}
                <div className="bmi-category" style={{ marginLeft: "3px" }}>
                  <div className="bmi-category ">
                    <span
                      className="obese-text"
                      style={
                        student[0]?.studentAssessment?.[0]?.metric?.bmi ==
                        "normal"
                          ? { color: "#17AB13", width: "0%" }
                          : student[0]?.studentAssessment?.[0]?.metric?.bmi ==
                              "overweight"
                            ? { color: "#FF9F00", width: "0%" }
                            : { color: "#EF343B", width: "0%" }
                      }
                    >
                      ({student[0]?.studentAssessment?.[0]?.metric?.bmi || "NA"}
                      )
                    </span>
                  </div>
                </div>{" "}
              </div>
            </div>
            <div className="col-md-2">
              <p className="preview-block-innercontent my-3">
                Anaemia:{" "}
                {student[0]?.studentAssessment &&
                student[0].studentAssessment.length > 0
                  ? checkAilmentKeyExists(
                      student[0].studentAssessment[
                        student[0].studentAssessment.length - 1
                      ],
                      "General_sign_anaemia",
                    )
                  : "N.A"}
              </p>
            </div>
            <div className="col-md-2">
              <p className="preview-block-innercontent my-3">
                Teeth & Gums:{" "}
                {student[0]?.studentAssessment &&
                student[0].studentAssessment.length > 0
                  ? checkAilmentKeyExists(
                      student[0].studentAssessment[
                        student[0].studentAssessment.length - 1
                      ],
                      [
                        "Chief_Complaint_Bleeding_Gums",
                        "Chief_Complaint_Decayed_Teeth",
                        "Chief_Complaint_Inflamed_Gums",
                      ],
                    )
                  : "N.A"}
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 d-flex justify-content-evenly mx-1 my-2">
            <div className="col-md-2">
              <p className="preview-block-innercontent">
                Right Eye:{" "}
                {student[0]?.studentAssessment?.[0]?.metric?.ailment?.find(
                  (ailment) => ailment.category == "optometry_right_eye",
                )
                  ? extractSixBySix(
                      student[0]?.studentAssessment?.[0]?.metric?.ailment?.find(
                        (ailment) => ailment.category == "optometry_right_eye",
                      ).label,
                    )
                  : "N/A"}
              </p>
            </div>

            <div className="col-md-2">
              <p className="preview-block-innercontent">
                Left Eye:{" "}
                {student[0]?.studentAssessment?.[0]?.metric?.ailment?.find(
                  (ailment) => ailment.category == "optometry_left_eye",
                )
                  ? extractSixBySix(
                      student[0]?.studentAssessment?.[0]?.metric?.ailment?.find(
                        (ailment) => ailment.category == "optometry_left_eye",
                      ).label,
                    )
                  : "N/A"}
              </p>
            </div>

            <div className="col-md-2">
              <p className="preview-block-innercontent">
                ENT:{" "}
                {student[0]?.studentAssessment &&
                student[0].studentAssessment.length > 0
                  ? checkAilmentKeyExists(
                      student[0].studentAssessment[
                        student[0].studentAssessment.length - 1
                      ],
                      [
                        "Right_Ear_Tinnitus",
                        "Left_Ear_Tinnitus",
                        "Left_Ear_Others",
                        "Right_Ear_Ear_Wax",
                        "Left_Ear_Pain",
                        "Left_Ear_Ear_Wax",
                        "Right_Ear_Others",
                        "Right_Ear_Pain",
                        "Right_Ear_Malformation",
                        "Right_Ear_Discharge",
                        "Left_Ear_Malformation",
                        "Left_Ear_Discharge",
                      ],
                    )
                  : "N.A"}
              </p>
            </div>
            <div className="col-md-2">
              <p className="preview-block-innercontent">
                Chest:{" "}
                {student[0]?.studentAssessment &&
                student[0].studentAssessment.length > 0
                  ? checkAilmentKeyExists(
                      student[0].studentAssessment[
                        student[0].studentAssessment.length - 1
                      ],
                      ["Xray_Chest", "Ultrasound_Chest"],
                    )
                  : "N.A"}
              </p>
            </div>
            <div className="col-md-2">
              <p className="preview-block-innercontent">
                Abdomen:{" "}
                {student[0]?.studentAssessment &&
                student[0].studentAssessment.length > 0
                  ? checkAilmentKeyExists(
                      student[0].studentAssessment[
                        student[0].studentAssessment.length - 1
                      ],
                      [
                        "Abdomen_Others",
                        "Abdomen_Distended",
                        "Abdomen_Tender",
                        "Abdomen_Tense",
                      ],
                    )
                  : "N.A"}
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 d-flex justify-content-evenly mx-1 my-2">
            <div className="col-md-2">
              <p className="preview-block-innercontent">
                Lymph Glands:
                {student[0]?.studentAssessment &&
                student[0].studentAssessment.length > 0
                  ? checkAilmentKeyExists(
                      student[0].studentAssessment[
                        student[0].studentAssessment.length - 1
                      ],
                      [
                        "Lymphatic_PLN_Others",
                        "Lymphatic_PLN_Cervical",
                        "Lymphatic_PLN_Submandibular",
                        "Lymphatic_PLN_Pre_Auricular",
                        "Lymphatic_PLN_Submental",
                      ],
                    )
                  : "N.A"}{" "}
              </p>
            </div>
            <div className="col-md-2">
              <p className="preview-block-innercontent">
                Food Allergy:{" "}
                {student[0].foodAllergies ? student[0].foodAllergies : "NA"}
              </p>
            </div>
            <div className="col-md-2">
              <p
                className="preview-block-innercontent"
                style={{ width: "180%" }}
              >
                Medicine Allergies:{" "}
                {student[0].medicineAllergies
                  ? student[0].medicineAllergies
                  : ""}
                N.A{" "}
              </p>
            </div>
            <div className="col-md-2">
              <p className="preview-block-innercontent">Health Issue: N.A.</p>
            </div>
            <div className="col-md-2">
              <p className="preview-block-innercontent">On Medication: N.A.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentCard;
